import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana87Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1461_5344)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M541.112 587.87L610.062 582.124L590.909 513.174L533.451 517.004L541.112 587.87Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M573.669 448.055C575.201 452.652 585.799 492.745 590.906 513.174L533.448 517.005L523.872 430.818L550.685 428.902C564.092 430.818 571.753 442.309 573.669 448.055Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M475.992 593.617L541.111 587.871L533.45 517.006L470.246 522.752L475.992 593.617Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M410.87 599.365L475.989 593.619L470.243 522.754L405.124 530.415L410.87 599.365Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M378.315 601.271L410.874 599.356L405.128 530.406L305.534 538.067L378.315 601.271Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M472.163 434.645L523.876 430.814L533.452 517.002L479.824 520.832L472.163 434.645Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M420.456 438.479L472.168 434.648L479.829 520.836L426.201 526.582L420.456 438.479Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M405.127 530.408L426.195 526.577L420.45 438.475L370.652 442.305L372.568 532.323L405.127 530.408Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M318.944 448.054L370.657 442.309L372.572 532.327L324.69 536.157L318.944 448.054Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M274.89 453.801L318.942 448.055L324.687 536.157L305.535 538.073L261.484 495.937C253.823 471.421 265.952 456.993 274.89 453.801Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1461_5344" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1461_5344" transform="matrix(0.00262712 0 0 0.00348286 -6.70186 -2.45688)"/>
    </pattern>
    <image id="image0_1461_5344" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};